// Utility for making authenticated API calls with JWT tokens

export const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('authToken');

  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // Add JWT token to Authorization header if available
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  // Handle token expiration
  if (response.status === 401) {
    // Token is expired or invalid, clear local storage and redirect to login
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    throw new Error('Authentication expired. Redirecting to login.');
  }

  return response;
};


// WEBPACK FOOTER //
// ./src/utils/apiClient.js